"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.openFileDialog = void 0;
var R = __importStar(require("../utils/ramda"));
/** Must be called from a user activation event, such as an `onClick`. */
function openFileDialog(_a) {
  var _b = _a.accept,
    accept = _b === void 0 ? "*" : _b,
    _c = _a.multiple,
    multiple = _c === void 0 ? false : _c,
    _d = _a.callback,
    callback = _d === void 0 ? R.N : _d,
    initializeWithCustomAttributes = _a.initializeWithCustomAttributes;
  var inputElement = document.createElement("input");
  inputElement.style.display = "none";
  inputElement.type = "file";
  inputElement.multiple = multiple;
  if (accept !== "*") inputElement.accept = accept;
  document.body.appendChild(inputElement);
  inputElement.addEventListener("change", function (arg) {
    //@ts-ignore
    callback(arg);
    document.body.removeChild(inputElement);
  });
  if (initializeWithCustomAttributes) {
    initializeWithCustomAttributes(inputElement);
  }
  // dispatch a click event to open the file dialog
  inputElement.dispatchEvent(new MouseEvent("click"));
}
exports.openFileDialog = openFileDialog;